import React from "react";
import { categories, policies } from "../../data/wholesaleProducts";

export default function FooterBar({ shop, openPolicy, go }) {
  const entries = Object.entries(policies);
  const groups = [
    entries.slice(0, 7),
    entries.slice(7, 14),
    entries.slice(14, 20),
    entries.slice(20, 26),
  ];
  return (
    <footer className="global-footer">
      <section className="footer-intro">
        <button
          className="footer-mark"
          onClick={() => go("home")}
          aria-label="VARSENIC home"
        >
          <img src="/varsenic-logo.svg" alt="VARSENIC" />
        </button>
        <h2>
          Leave room
          <br />
          for the sound.
        </h2>
        <form onSubmit={(event) => event.preventDefault()}>
          <label>
            THE VARSENIC SIGNAL
            <input type="email" required placeholder="Email address" />
          </label>
          <button>JOIN →</button>
        </form>
      </section>
      <section className="footer-links">
        <div>
          <b>PRODUCTS</b>
          {categories.slice(1).map((item) => (
            <button key={item} onClick={() => shop(item)}>
              {item}
            </button>
          ))}
        </div>
        <div>
          <b>COMPANY</b>
          <button onClick={() => go("about")}>Our approach</button>
          <button onClick={() => go("contact")}>Support</button>
          <button onClick={() => openPolicy("recycling")}>Recycling</button>
          <button onClick={() => openPolicy("accessibility")}>
            Accessibility
          </button>
        </div>
        <div>
          <b>ESSENTIAL</b>
          {[
            ["shipping", "Shipping"],
            ["returns", "Returns"],
            ["warranty", "Warranty"],
            ["privacy", "Privacy"],
            ["terms", "Terms"],
          ].map(([key, label]) => (
            <button key={key} onClick={() => openPolicy(key)}>
              {label}
            </button>
          ))}
        </div>
        <div>
          <b className="uppercase">Contact us</b>
          <p>90 Commonwealth Cl, Block 90, Singapore 140090</p>
        </div>
      </section>
      <section className="footer-policy-directory">
        <header>
          <div>
            <b>POLICIES + GUIDES</b>
            <p>Complete shopping, safety and support information.</p>
          </div>
          <span>26 GUIDES</span>
        </header>
        <div className="footer-policy-grid">
          {groups.map((group, column) => (
            <div key={column}>
              {group.map(([key, value], index) => (
                <button key={key} onClick={() => openPolicy(key)}>
                  <small>
                    {String(
                      column < 2
                        ? column * 7 + index + 1
                        : 14 + (column - 2) * 6 + index + 1,
                    ).padStart(2, "0")}
                  </small>
                  <span>{value.nav}</span>
                  <i>→</i>
                </button>
              ))}
            </div>
          ))}
        </div>
      </section>
      <section className="footer-bottom">
        <span>© 2026 VARSENIC AUDIO</span>
        <span>ORIGINAL DEMONSTRATION STORE</span>
        <span>DESIGNED FOR LISTENING</span>
      </section>
    </footer>
  );
}
